// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { italicI16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-italic-i': IconItalicI;
    }
}

/**
 * The icon component for the 'italicI' icon
 */
export class IconItalicI extends IconSvg {
    public constructor() {
        super(italicI16X16);
    }
}

registerIconSvg('icon-italic-i', IconItalicI);
export const iconItalicITag = 'nimble-icon-italic-i';
